import {Command} from "./Command";
import {GamePlay} from "../model/game-play";

export class ResetPenaltyYardsKickoffCommand implements Command {
  constructor(
    private gamePlay: GamePlay
  ) { }

  execute() {
    console.log('COMMAND ResetPenaltyYardsKickoffCommand', this.gamePlay)

    this.gamePlay.penYardsKickoff = undefined
  }
}
